<script>
import transitionFade from '@/components/transition/fade.vue';
export default {
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        value: {
            type: [String, Number]
        },
        params: {
            type: Object
        }
    },
    data() {
        return {
            innerValue: this.value,
            isError: false
        };
    },
    components: {
        transitionFade
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        input(val) {
            this.$emit('input', val);
            this.checkInput(val);
        },
        checkInput(val) {
            if (this.params.verify.input && !this.params.verify.input(val) && val !== '') {
                this.isError = true;
            } else {
                this.isError = false;
            }
        },
        checkChange() {
            if (this.params.verify.change && !this.params.verify.change(this.innerValue)) {
                this.isError = true
            }
            return this.isError;
        },
        clear() {
            this.input('');
        }
    },
    watch: {
        value() {
            this.innerValue = this.value;
        }
    }
}
</script>

<template>
<div class="label-wrap">
    <div class="label-input">
        <em @click="focus">{{params.label}}</em>
        <input
            ref="input"
            type="text"
            autocomplete="off"
            :value="innerValue"
            :placeholder="params.placeholder"
            :maxlength="params.maxLength"
            @input="input($event.target.value)"
        >
        <transition-fade>
            <div class="clear" v-if="innerValue !== ''" @click="clear">
                <img src="../../assets/clear.png" alt="">
            </div>
        </transition-fade>
    </div>
    <transition-fade>
        <p class="error" v-if="isError">{{params.errMsg}}</p>
    </transition-fade>
</div>
</template>

<style lang="stylus" scoped>
.label-input.label-error
    border-color #f60
.label-input
    position relative
    display flex
    flex-direction row
    align-items center
    padding-right 1.4rem
    border-bottom 0.053rem solid #ebebeb
    transition all .225s cubic-bezier(0, 0, 0.2, 1)
    em
        width 4.5rem
        min-width 4.5rem
        line-height 1.6
        font-size 0.85rem
        font-style normal
        color #333
    .clear
        position absolute
        right 0
        top 0
        bottom 0
        margin auto
        padding .2rem
        min-width 1.3rem
        width 1.3rem
        height 1.3rem
        box-sizing border-box
        img
            width 100%
            height 100%
    input
        flex 1
        padding 0.74rem 0 0.74rem 0
        vertical-align middle
        line-height 1.6
        border 0
        box-shadow none
        box-sizing border-box
        font-size 0.85rem
        color #333
        outline 0
        overflow hidden
.label-wrap
    .error
        margin-top 0.2rem
        line-height 1.2
        font-size 0.64rem
        white-space nowrap
        color #f60
</style> 